import { ReactNode } from "react";
import BackgroundImage from "../../assets/images/jpg/SignInPageMask.jpg";
import DashLogo from "../../assets/images/png/SignInLogo.png";

type AuthPagesLayoutProps = {
  children: ReactNode;
};

export function AuthPagesLayout(props: AuthPagesLayoutProps) {
  return (
    <div className="flex flex-col w-screen h-screen">
      <div className="flex h-full">
        <div className="bg-sky-700 w-0 lg:w-5/12 flex items-center justify-center relative">
          <img
            src={BackgroundImage}
            alt="Dash Buildings"
            className="absolute left-0 top-0 object-cover h-full w-full"
          />
          <img src={DashLogo} alt="Dash Logo" className="absolute" />
        </div>
        <div className="bg-slate-50 w-full lg:w-7/12">{props.children}</div>
      </div>
      <footer className="flex flex-col sm:flex-row bg-slate-900 items-center justify-center sm:h-14 shrink-0 gap-2 sm:gap-8 py-4">
        <a href="" className="text-white text-sm underline underline-offset-4">
          Terms & Conditions
        </a>
        <a href="" className="text-white text-sm underline underline-offset-4">
          Privacy Policy
        </a>
        <p className="text-white text-sm">2025 Dash Inc. All Rights Reserved</p>
      </footer>
    </div>
  );
}
